module.exports = __webpack_public_path__ + "img/yellowinfo.678839ff.svg";